import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { useCare } from '../contexts/CareContext'
import { useState } from 'react'
import { isFreePlan, PLANS } from '../lib/plan'
import RequestCallModal from '../components/shared/RequestCallModal'
import AdminClientPanel from '../components/admin/AdminClientPanel'

const LINKS = [
  { to: '/team', icon: '👥', label: 'Team', desc: 'Care team and invites' },
  { to: '/profile', icon: '👤', label: 'Care profile', desc: 'Conditions, contacts, baselines' },
  { to: '/care-plan-actions', icon: '📋', label: 'Care plan', desc: 'Actions and progress per goal' },
  { to: '/medications', icon: '💊', label: 'Medications', desc: 'Doses, timing, refills' },
  { to: '/appointments', icon: '📅', label: 'Appointments', desc: 'Upcoming and past visits' },
  { to: '/documents', icon: '📄', label: 'Documents', desc: 'Lab results, letters, legal' },
  { to: '/reports', icon: '🩺', label: 'Doctor summary', desc: '30-day summary for the GP' },
]

export default function MorePage() {
  const navigate = useNavigate()
  const { profile, signOut } = useAuth()
  const { role, recipient, isAdmin, isAdminAnywhere } = useCare()
  const [callModal, setCallModal] = useState(null)
  const [adminOpen, setAdminOpen] = useState(false)

  return (
    <div className="stack">
      <h1 className="title">More</h1>

      <div className="stack" style={{ gap: 8 }}>
        {isAdminAnywhere && (
          <button className="card card-tap" onClick={() => navigate('/admin')}>
            <div className="row">
              <span style={{ fontSize: 22 }} aria-hidden>👥</span>
              <div className="grow">
                <div style={{ fontWeight: 700 }}>All clients</div>
                <div className="muted" style={{ fontSize: 13 }}>Overview of all care recipients</div>
              </div>
              <span className="muted" aria-hidden>→</span>
            </div>
          </button>
        )}
        {isAdminAnywhere && (
          <button className="card card-tap" onClick={() => navigate('/admin#caregivers')}>
            <div className="row">
              <span style={{ fontSize: 22 }} aria-hidden>🧑‍⚕️</span>
              <div className="grow">
                <div style={{ fontWeight: 700 }}>Caregivers</div>
                <div className="muted" style={{ fontSize: 13 }}>Everyone working across your clients</div>
              </div>
              <span className="muted" aria-hidden>→</span>
            </div>
          </button>
        )}
        {isAdmin && recipient && (
          <button className="card card-tap" onClick={() => setAdminOpen(true)}>
            <div className="row">
              <span style={{ fontSize: 22 }} aria-hidden>⚙️</span>
              <div className="grow">
                <div style={{ fontWeight: 700 }}>
                  Admin — {recipient.preferred_name || recipient.full_name}
                </div>
                <div className="muted" style={{ fontSize: 13 }}>Team, tasks, care plan</div>
              </div>
              <span className="muted" aria-hidden>→</span>
            </div>
          </button>
        )}
        {LINKS.map((l) => (
          <button key={l.to} className="card card-tap" onClick={() => navigate(l.to)}>
            <div className="row">
              <span style={{ fontSize: 22 }} aria-hidden>{l.icon}</span>
              <div className="grow">
                <div style={{ fontWeight: 700 }}>{l.label}</div>
                <div className="muted" style={{ fontSize: 13 }}>{l.desc}</div>
              </div>
              <span className="muted" aria-hidden>→</span>
            </div>
          </button>
        ))}
      </div>

      {/* Upgrade cards — free plan only */}
      {isFreePlan(recipient) && (
        <div>
          <div className="section-title" style={{ marginBottom: 8 }}>Add daily support</div>
          <div className="stack" style={{ gap: 10 }}>
            {PLANS.map((p) => (
              <button
                key={p.key}
                type="button"
                className="card card-tap"
                onClick={() => setCallModal(p.key)}
                style={{ borderColor: 'var(--pa)', borderWidth: 1.5, display: 'block', color: 'inherit', width: '100%' }}
              >
                <div className="spread">
                  <div style={{ fontWeight: 700, color: 'var(--pa)' }}>{p.name}</div>
                  <div style={{ fontWeight: 700 }}>
                    {p.price}
                    <span className="muted" style={{ fontWeight: 400, fontSize: 13 }}>{p.cadence}</span>
                  </div>
                </div>
                <div className="muted" style={{ fontSize: 14, marginTop: 4, lineHeight: 1.5, textAlign: 'left' }}>
                  {p.blurb}
                </div>
              </button>
            ))}
          </div>
        </div>
      )}

      <div className="card">
        <div className="section-title">Signed in as</div>
        <div style={{ fontWeight: 700, marginTop: 4 }}>{profile?.full_name}</div>
        <div className="muted" style={{ fontSize: 14 }}>{profile?.email}</div>
        {role && (
          <span className="badge mt-8" style={{ textTransform: 'capitalize' }}>
            {role.replace('_', ' ')}
          </span>
        )}
      </div>

      <button className="btn btn-ghost btn-block" onClick={() => signOut()}>
        Sign out
      </button>

      <div style={{ height: 8 }} />

      {adminOpen && (
        <AdminClientPanel onClose={() => setAdminOpen(false)} />
      )}

      {callModal && (
        <RequestCallModal plan={callModal} onClose={() => setCallModal(null)} />
      )}
    </div>
  )
}
